import axios from 'axios';
import jwt_decode from 'jwt-decode';
import i18n from '../i18n';

const TOKEN_STORAGE_KEY = 'ccAdmin.currentUser';
const MODULES_STORAGE_KEY = 'modules';
const LOGIN_HASH = '#/login';

const isTokenExpired = (token) => {
  try {
    const { exp } = jwt_decode(token);
    return typeof exp === 'number' && Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};

const clearAuthAndRedirect = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(MODULES_STORAGE_KEY);
  if (window.location.hash !== LOGIN_HASH) {
    window.location.href = `/${LOGIN_HASH}`;
  }
};

export const getToken = () => {
  const jsonToken = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (!jsonToken) return undefined;

  const { token } = JSON.parse(jsonToken);
  if (!token || isTokenExpired(token)) {
    clearAuthAndRedirect();
    return undefined;
  }
  return token;
};

const getAxiosInstance = () => {
  const network = axios.create({
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    validateStatus: (status) => {
      return status >= 200 && status < 300;
    }
  });

  network.interceptors.response.use(
    (response) => response,
    (error) => {
      const { config, response } = error;

      if (!response) {
        error.message = i18n.t('error.network');
        return Promise.reject(error);
      }

      const isLoginUrl = config.url.endsWith('/login');

      if (response.status === 401 && !isLoginUrl) {
        clearAuthAndRedirect();
      }

      return Promise.reject(response);
    }
  );

  return network;
};

export const getNetwork = getAxiosInstance;

// Интерсептор реджектит либо response (HTTP-ошибка), либо axios-error (нет ответа).
// Достаём статус из обоих вариантов, чтобы страницы могли отличить 403 и т.п.
export const getErrorStatus = (err) =>
  (err && err.status) || (err && err.response && err.response.status) || null;

// Тело ошибки лежит в response.data (HTTP-ошибка) либо в err.response.data (axios-error).
const getErrorData = (err) =>
  (err && err.data) || (err && err.response && err.response.data) || null;

// Бек на отсутствие прав отвечает 403 с телом { code: "ACCESS_DENIED" }.
export const isAccessDeniedError = (err) => {
  const data = getErrorData(err);
  return getErrorStatus(err) === 403 && Boolean(data) && data.code === 'ACCESS_DENIED';
};

// При дубле мероприятия бек отвечает кодом M.ERROR.06 (на create — 403, на edit — 400),
// поэтому ориентируемся на код, а не на HTTP-статус.
export const isEventAlreadyExistsError = (err) => {
  const data = getErrorData(err);
  return Boolean(data) && data.code === 'M.ERROR.06';
};